import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import {
  AccBusinessProfessionalIncome,
  AccCapitalGainsIncome,
  AccHousePropertyIncome,
  AccOtherSourcesIncome,
  AccSalaryIncome,
  AccVirtualDigitalAssets
} from ".";
import { IActiveTabs, IFormITR1 } from "../../../config/interfaces";
import PreventEditComponent from "../../PreventEditComponent";
import PriceDisplay from "../../PriceDisplay";
import SvgImage from "../../SvgImage";

type Props = {
  handleOnPressEdit: (tabName: IActiveTabs) => void;
};

const ReviewIncomeDetails: React.FC<Props> = (props: Props) => {
  const { handleOnPressEdit } = props;

  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      <Accordion.Item eventKey="review-file-1">
        <Accordion.Header onClick={() => null}>
          <div className="btn-content">
            <SvgImage imgId="other-income-information" />
            <h4 className="mb-0">Income Sources</h4>
          </div>
          <PreventEditComponent>
            <span
              role="button"
              className="btn btn-link"
              onClick={() => handleOnPressEdit("income-details")}
            >
              Edit
            </span>
          </PreventEditComponent>
        </Accordion.Header>
        <Accordion.Body>
          <hr />
          {values.GrossTotIncome ? (
            <Accordion className="accordion-sm">
              {/* Salary Income */}
              <AccSalaryIncome />

              {/* House Property Income */}
              <AccHousePropertyIncome />

              {/* Business and Professional Income */}
              <AccBusinessProfessionalIncome />

              {/* Capital Gains */}
              <AccCapitalGainsIncome />

              {/* Other Sources */}
              <AccOtherSourcesIncome />

              {/* Virtual Digital Assets (VDA) */}
              <AccVirtualDigitalAssets />
            </Accordion>
          ) : null}

          <dl className="eds-list eds-dl eds-inline-between">
            <div className="eds-list--item eds-list--item-total">
              <dt>Gross Total Income</dt>
              <dd>
                <PriceDisplay price={values.GrossTotIncome} />
              </dd>
            </div>
          </dl>
        </Accordion.Body>
      </Accordion.Item>
    </>
  );
};

export default ReviewIncomeDetails;
